import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'
import Notifications from 'src/components/notifications/NotificationsToaster'

import { useValidCode } from 'src/hooks/useAuthHooks'
import { Code } from 'src/components/auth/authComponents'
import Timer from 'src/components/timer/Timer'
import Honeypot from 'src/components/hidden/Honeypot'

const ValidateForgotPassword = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false)

  const { code, setCode, codeIsValid } = useValidCode('')
  const [fetchError, setFetchError] = useState('')
  const [isTimerDone, setIsTimerDone] = useState(false)

  const isValid = !codeIsValid || code.length === 0

  const validateCode = async () => {
    setIsSpinnerVisible(true)
    try {
      localStorage.setItem('confirmationCode', code)
      navigate('/new-password')
    } catch (err) {
      setFetchError(err.message)
      resetForm()
    } finally {
      setIsSpinnerVisible(false)
    }
  }

  const resetForm = () => {
    document.getElementById('validate-forgot-password-form').reset()
    setCode('')
  }
  //reset errors
  useEffect(() => {
    if (code !== '') setFetchError(false)
  }, [code])

  //onLoad, check if user has stored with an "active" code
  //if not, go away
  useEffect(() => {
    if (!localStorage.getItem('codeRequestedBy') || !localStorage.getItem('codeExpiresAt'))
      navigate('/tender-overview')
  }, [])

  //when code "expires", go away
  useEffect(() => {
    if (isTimerDone) navigate('/')
  }, [isTimerDone])

  return (
    <div className='bg-body-tertiary min-vh-100 d-flex flex-row align-items-center'>
      {fetchError ? <Notifications type='error' message={fetchError} /> : null}
      {/* Honey */}
      <Honeypot />
      {/* Honey */}
      <CContainer>
        <CRow className='justify-content-center'>
          <CCol md={5}>
            <CCard className='p-4'>
              <CCardBody>
                <CForm id='validate-forgot-password-form'>
                  <h1>{t('ValidateCode.pageTitle')}</h1>
                  <CInputGroup className='mb-3'>
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>
                    <Code codeIsValid={codeIsValid} setCode={setCode} />
                  </CInputGroup>
                  <Timer
                    message={t('ValidateCode.message') + ' '}
                    storageItem='codeExpiresAt'
                    callback={setIsTimerDone}
                  />
                  <CButton
                    disabled={isValid}
                    color='primary'
                    onClick={validateCode}
                    className='px-4'
                    tabIndex={-1}
                  >
                    {isSpinnerVisible ? (
                      <CSpinner color='light' variant='grow' size='sm' />
                    ) : (
                      t('ValidateCode.button')
                    )}
                  </CButton>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default ValidateForgotPassword
